<template>
  <div class="csj-redesign">
    <div class="corner-ribbon">
      <v-btn text @click="$router.go(-1)" class="back-link">
        <v-icon left>mdi-arrow-left</v-icon>
        Volver página anterior
      </v-btn>
    </div>

    <v-app-bar app flat color="transparent" class="csj-appbar">
      <v-toolbar-title class="brand">
        <span class="small">Colegio</span>
        <strong>San Juan</strong>
      </v-toolbar-title>
      <v-spacer />
      <v-btn text v-for="link in links" :key="link.href" :href="link.href">{{ link.label }}</v-btn>
      <v-btn color="secondary" dark class="ml-4" href="#contacto">Admisiones</v-btn>
    </v-app-bar>

    <section class="hero">
      <div class="hero-overlay">
        <v-container>
          <v-row>
            <v-col cols="12" md="7" class="hero-copy">
              <div class="badge">Educación con propósito</div>
              <h1>Formamos líderes del mañana con ciencia y valores</h1>
              <p class="lead">Modelo pedagógico STEAM, laboratorios y acompañamiento personalizado.</p>
              <div class="hero-ctas">
                <v-btn large color="secondary" dark href="#contacto">Agenda tu visita</v-btn>
                <v-btn large outlined color="secondary" href="#propuesta">Conoce más</v-btn>
              </div>
              <div class="stats">
                <div>
                  <strong>56</strong>
                  <span>Años</span>
                </div>
                <div>
                  <strong>+1k</strong>
                  <span>Estudiantes</span>
                </div>
                <div>
                  <strong>100%</strong>
                  <span>Atención personalizada</span>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="5" class="hero-media">
              <v-card elevation="6" class="media-card">
                <v-img
                  src="https://images.pexels.com/photos/414519/pexels-photo-414519.jpeg?auto=compress&cs=tinysrgb&w=1200"
                  aspect-ratio="1.2"
                />
                <v-card-text>
                  <div class="media-caption">Aulas, laboratorios y espacios deportivos</div>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </section>

    <section id="propuesta" class="features">
      <v-container>
        <v-row>
          <v-col cols="12" md="4" v-for="(f, i) in features" :key="i">
            <v-card class="feature-card" outlined>
              <v-img :src="f.image" height="200px" class="feature-image" />
              <v-card-title>{{ f.title }}</v-card-title>
              <v-card-text>{{ f.text }}</v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section id="niveles" class="levels">
      <v-container>
        <h2 class="section-title">Nuestros niveles</h2>
        <v-row>
          <v-col cols="12" md="4" v-for="(level, index) in levels" :key="index">
            <v-sheet class="level-card" elevation="4">
              <v-img :src="level.image" height="170px" class="level-image" />
              <div class="level-content">
                <h3>{{ level.title }}</h3>
                <p>{{ level.text }}</p>
              </div>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section id="instalaciones" class="campus">
      <v-container>
        <v-row align="center">
          <v-col cols="12" md="6">
            <v-img
              src="https://images.pexels.com/photos/256490/pexels-photo-256490.jpeg?auto=compress&cs=tinysrgb&w=1000"
              aspect-ratio="1.3"
              class="campus-image"
            />
          </v-col>
          <v-col cols="12" md="6">
            <h2>Instalaciones modernas</h2>
            <ul>
              <li>Laboratorios equipados</li>
              <li>Canchas y piscina</li>
              <li>Aulas inteligentes</li>
            </ul>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section id="contacto" class="contact">
      <v-container>
        <v-row>
          <v-col cols="12" md="8">
            <h2>Visítanos</h2>
            <p>Agenda una visita guiada y conoce nuestro proyecto educativo.</p>
          </v-col>
          <v-col cols="12" md="4" class="contact-cta">
            <v-btn large color="secondary" dark href="https://wa.me/51987654321">Contactar por WhatsApp</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <footer class="csj-footer">
      <v-container>
        <v-row>
          <v-col cols="12" md="6">
            <strong>Colegio San Juan</strong>
            <p>Tradición y futuro en educación.</p>
          </v-col>
          <v-col cols="12" md="6" class="footer-links">
            <p>Jr. Principal 123 — +51 1 234 5678 — contacto@colegiosanjuan.edu.pe</p>
          </v-col>
        </v-row>
      </v-container>
    </footer>
  </div>
</template>

<script>
export default {
  name: "ColegioSanJuan",
  data() {
    return {
      links: [
        { label: "Inicio", href: "#inicio" },
        { label: "Propuesta", href: "#propuesta" },
        { label: "Niveles", href: "#niveles" },
        { label: "Instalaciones", href: "#instalaciones" },
        { label: "Contacto", href: "#contacto" },
      ],
      features: [
        {
          title: "Pedagogía Activa",
          text: "Aprendizaje por proyectos y acompañamiento.",
          image: "https://images.pexels.com/photos/1181446/pexels-photo-1181446.jpeg?auto=compress&cs=tinysrgb&w=1200",
        },
        {
          title: "Laboratorios",
          text: "Ciencia y tecnología en cada etapa.",
          image: "https://images.pexels.com/photos/256488/pexels-photo-256488.jpeg?auto=compress&cs=tinysrgb&w=1200",
        },
        {
          title: "Valores",
          text: "Formación ética y socioemocional.",
          image: "https://images.pexels.com/photos/3184290/pexels-photo-3184290.jpeg?auto=compress&cs=tinysrgb&w=1200",
        },
      ],
      levels: [
        {
          title: "Inicial",
          text: "Estimulación temprana y cuidado afectivo.",
          image: "https://images.pexels.com/photos/3662622/pexels-photo-3662622.jpeg?auto=compress&cs=tinysrgb&w=1200",
        },
        {
          title: "Primaria",
          text: "Aprendizaje por proyectos y pensamiento crítico.",
          image: "https://images.pexels.com/photos/4143791/pexels-photo-4143791.jpeg?auto=compress&cs=tinysrgb&w=1200",
        },
        {
          title: "Secundaria",
          text: "Preparación preuniversitaria y orientación vocacional.",
          image: "https://images.pexels.com/photos/1181672/pexels-photo-1181672.jpeg?auto=compress&cs=tinysrgb&w=1200",
        },
      ],
    };
  },
};
</script>

<style scoped>
.csj-redesign {
  font-family: "Roboto", sans-serif;
  color: #102027;
}
.csj-appbar {
  position: relative;
  background: rgba(255,255,255,0.88) !important;
  backdrop-filter: blur(12px);
}
.brand .small {
  display: block;
  font-size: 0.75rem;
  color: #1e88e5;
  text-transform: uppercase;
}
.hero {
  background: linear-gradient(180deg, rgba(6,63,117,0.75), rgba(7,105,170,0.35)),
    url('https://images.pexels.com/photos/414519/pexels-photo-414519.jpeg?auto=compress&cs=tinysrgb&w=1600') center/cover no-repeat;
  color: white;
  padding: 120px 0 80px;
}
.hero-overlay {
  padding: 60px 0;
}
.badge {
  background: rgba(255,255,255,0.12);
  display: inline-block;
  padding: 8px 12px;
  border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin-bottom: 18px;
}
.hero-copy h1 {
  font-size: 3rem;
  line-height: 1.05;
  margin: 0 0 18px;
}
.lead {
  color: rgba(255,255,255,0.9);
  max-width: 540px;
  margin-bottom: 26px;
}
.hero-ctas {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 28px;
}
.stats {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}
.stats div {
  background: rgba(255,255,255,0.11);
  border: 1px solid rgba(255,255,255,0.18);
  padding: 16px 20px;
  border-radius: 14px;
  min-width: 140px;
}
.stats strong {
  display: block;
  font-size: 1.7rem;
  margin-bottom: 6px;
}
.media-card {
  overflow: hidden;
  border-radius: 24px;
}
.media-caption {
  color: #102027;
  font-weight: 700;
}
.features {
  padding: 56px 0;
}
.feature-card {
  min-height: 260px;
  border-radius: 20px;
  overflow: hidden;
}
.feature-image {
  object-fit: cover;
}
.level-card {
  padding: 0;
  border-radius: 20px;
  overflow: hidden;
}
.level-image {
  object-fit: cover;
}
.level-content {
  padding: 24px;
}
.section-title {
  text-align: center;
  margin-bottom: 28px;
  font-size: 2rem;
  color: #102027;
}
.levels {
  padding: 52px 0;
}
.level-card {
  padding: 28px;
  border-radius: 20px;
  background: #ffffff;
}
.campus {
  padding: 52px 0;
}
.campus h2 {
  margin-bottom: 20px;
}
.campus ul {
  list-style: none;
  padding: 0;
}
.campus li {
  margin-bottom: 10px;
}
.contact {
  padding: 48px 0;
  background: #f4f9ff;
}
.contact-cta {
  display: flex;
  align-items: center;
  justify-content: center;
}
.csj-footer {
  padding: 48px 0;
  background: linear-gradient(180deg, #06293e 0%, #08385b 100%);
  color: #ffffff;
}
.csj-footer strong {
  color: #ffffff;
  font-size: 1.1rem;
}
.csj-footer p {
  color: rgba(255,255,255,0.9);
  margin: 6px 0 0;
}
.footer-links p {
  color: rgba(255,255,255,0.8);
  text-align: right;
  margin: 0;
}
.back-action {
  width: 100%;
  padding: 16px 24px;
  background: #f5f8fc;
}
.back-link {
  color: #102027;
  font-weight: 700;
}
@media (max-width: 960px) {
  .hero-copy h1 {
    font-size: 2.1rem;
  }
  .stats {
    flex-direction: column;
  }
  .footer-links p {
    text-align: center;
    margin-top: 12px;
  }
}
.corner-ribbon {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 2000;
  background: rgba(255,255,255,0.95);
  padding: 8px 12px;
  border-radius: 999px;
  box-shadow: 0 10px 32px rgba(16, 32, 39, 0.12);
}
.corner-ribbon .back-link {
  color: #102027;
  font-weight: 700;
  text-transform: none;
}
</style>
